import * as Actions from '../../actions/payments/type';

const initialState = {
  makePaymentLoading: false,
  makePaymentSuccess: '',
  makePaymentError: '',

  getPaymentsByRoLoading: false,
  getPaymentsByRo: [],
  getPaymentsByRoError: '',

  getApprovedJobsLoading: false,
  getApprovedJobsSuccess: '',
  getApprovedJobsError: '',

  getPaymentsLoading: false,
  getPayments: [],
  getPaymentsError: '',

  paymentNotesLoading: false,
  paymentNotesSuccess: false,
  paymentNotesError: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.MAKE_PAYMENT_REQUEST:
      return { ...state, makePaymentLoading: true };

    case Actions.MAKE_PAYMENT_SUCCESS:
      const payments = state.getPaymentsByRo || [];
      const payment = action.payload?.data.data || '';
      const actionType = action.payload?.actionType;
      if (payment?.id && actionType && actionType === 'voided') {
        const updatedPayments = payments.map((p) => {
          if (p.id === payment.id) {
            return { ...p, voided: true };
          }
          return p;
        });

        return {
          ...state,
          makePaymentLoading: false,
          makePaymentSuccess: payment || '',
          getPaymentsByRo: updatedPayments,
        };
      }
      if (payment?.id && actionType && actionType === 'notes update') {
        const updatedPayments = payments.map((p) => {
          if (p.id === payment.id) {
            return { ...p, notes: payment.notes };
          }
          return p;
        });

        return {
          ...state,
          makePaymentLoading: false,
          makePaymentSuccess: payment || '',
          getPaymentsByRo: updatedPayments,
        };
      }
      if (payment?.id) {
        payments.unshift(payment); // Add the new payment at the start of the array
      }
      return {
        ...state,
        makePaymentLoading: false,
        makePaymentSuccess: payment || '',
        getPaymentsByRo: payments,
      };

    case Actions.MAKE_PAYMENT_FAIL:
      return {
        ...state,
        makePaymentLoading: false,
        makePaymentError: action.payload,
      };

    case Actions.GET_PAYMENTS_BY_RO_REQUEST:
      return { ...state, getPaymentsByRoLoading: true };

    case Actions.GET_PAYMENTS_BY_RO_SUCCESS:
      return {
        ...state,
        getPaymentsByRoLoading: false,
        getPaymentsByRo: action.payload?.data || [],
      };

    case Actions.GET_PAYMENTS_BY_RO_FAIL:
      return {
        ...state,
        getPaymentsByRoLoading: false,
        getPaymentsByRoError: action.payload,
      };

    case Actions.GET_APPROVED_JOBS_REQUEST:
      return { ...state, getApprovedJobsLoading: true };

    case Actions.GET_APPROVED_JOBS_SUCCESS:
      return {
        ...state,
        getApprovedJobsLoading: false,
        getApprovedJobsSuccess: action.payload?.data || '',
      };

    case Actions.GET_APPROVED_JOBS_FAIL:
      return {
        ...state,
        getApprovedJobsLoading: false,
        getApprovedJobsError: action.payload,
      };

    case Actions.GET_PAYMENTS_REQUEST:
      return { ...state, getPaymentsLoading: true };

    case Actions.GET_PAYMENTS_SUCCESS:
      return {
        ...state,
        getPaymentsLoading: false,
        getPayments: action.payload?.data || [],
      };

    case Actions.GET_PAYMENTS_FAIL:
      return {
        ...state,
        getPaymentsLoading: false,
        getPaymentsError: action.payload,
      };

    case Actions.CLEAR_APPROVED_JOBS_STATE:
      return {
        ...state,
        getApprovedJobsLoading: false,
        getApprovedJobsSuccess: '',
        getApprovedJobsError: '',
      };

    case Actions.CLEAR_PAYMENT_STATE:
      return {
        ...state,
        makePaymentLoading: false,
        makePaymentSuccess: '',
        makePaymentError: '',
      };
    case Actions.ADD_EDIT_PAYMENT_NOTES_REQUEST:
      return {
        ...state,
        paymentNotesLoading: true,
        paymentNotesSuccess: false,
      };

    case Actions.ADD_EDIT_PAYMENT_NOTES_SUCCESS: {
      const paymentData = state.getPaymentsByRo || [];
      const notes = action.payload || {};
      if (notes.paymentId) {
        const updatedPayments = paymentData.map((p) => {
          if (p.id === notes.paymentId) {
            return { ...p, notes: notes.notes || '' };
          }
          return p;
        });
        return {
          ...state,
          paymentNotesLoading: false,
          getPaymentsByRo: updatedPayments,
          paymentNotesSuccess: true,
        };
      }
      return {
        ...state,
        paymentNotesLoading: false,
      };
    }

    case Actions.ADD_EDIT_PAYMENT_NOTES_FAIL:
      return {
        ...state,
        paymentNotesLoading: false,
        paymentNotesError: action.payload,
      };
    default:
      return state;
  }
}
